module.exports = __webpack_public_path__ + "static/media/header-case-studies.af24ad10.svg";